/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { EmbedComponentDisplay } from "cms/components/components/embed/display";
import { EmbedComponentEditor } from "cms/components/components/embed/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const EmbedComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <EmbedComponentDisplay />,
        editComponent: <EmbedComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

EmbedComponent.displayName = "EmbedComponent";
export { EmbedComponent };
